import { axios } from "@/utils/request";

// 代理商添加
export function agentAdd(data) {
  return axios({
    url: '/agentProcess/add',
    method: 'post',
    data
  })
}

// 2010301 获取public-bucket操作权限
export function getPublicBucketInfo(data) {
  return axios({
    url: '/ossPublic/getPublicBucketInfo',
    method: 'post',
    data
  })
}

// 门店添加
export function shopAdd(data) {
  return axios({
    url: '/shopProcess/add',
    method: 'post',
    data
  })
}

// 2010401 获取所有省市县信息
export function getAllSystemCityVoTree(data) {
  return axios({
    url: '/systemCity/getAllSystemCityVoTree',
    method: 'post',
    data
  })
}
